import { render, staticRenderFns } from "./navTabs.vue?vue&type=template&id=b74ef942&scoped=true"
import script from "./navTabs.vue?vue&type=script&lang=js"
export * from "./navTabs.vue?vue&type=script&lang=js"
import style0 from "./navTabs.vue?vue&type=style&index=0&id=b74ef942&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74ef942",
  null
  
)

export default component.exports